import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState, useRef } from 'react';
import { Grid } from '@mui/material';
import { AccountCircle } from '@mui/icons-material';
import { styled } from '@mui/material';
import { H5 } from '../../atoms/typography';
import { Alert } from '../../atoms/Alert';
import Button from '../../atoms/Button';
import Logo from '../../atoms/Logo';
import Scanner from '../../molecules/Scanner';
import { standardContainerStyling } from '../../../styling';
const LoginFormContainer = styled('div') `
  ${standardContainerStyling()}
`;
export const LoginForm = ({ onSubmit, alert = undefined, isLoading = false, useSessionStorage = false, }) => {
    const [badge, setBadge] = useState(() => {
        try {
            return sessionStorage.getItem('loginBadgeInput') ?? '';
        }
        catch {
            return '';
        }
    });
    const [error, setError] = useState();
    useEffect(() => {
        setError(alert?.severity === 'error' ? alert.detail : undefined);
    }, [alert?.severity]);
    const isFirstRender = useRef(true);
    useEffect(function setSessionStorage() {
        // Don't overwrite the sessionStorage on first render (just read from it)
        if (!isFirstRender.current && useSessionStorage) {
            try {
                sessionStorage.setItem('loginBadgeInput', badge);
            }
            catch {
                console.warn('Failed to set sessionStorage for loginBadgeInput');
            }
        }
        isFirstRender.current = false;
    }, [badge]);
    const handleSubmit = (event) => {
        const value = event?.target?.value ?? badge;
        if (value) {
            onSubmit(value);
        }
        else {
            setError('Must enter badge');
        }
    };
    const handleChange = (event) => {
        const value = event?.currentTarget?.value ?? '';
        // useSessionStorage && sessionStorage.setItem('loginBadgeInput', value);
        setBadge(value);
        setError(undefined);
    };
    const handleClear = () => {
        setBadge('');
        setError(undefined);
        // useSessionStorage && sessionStorage.setItem('loginBadgeInput', '');
    };
    return (_jsx(LoginFormContainer, { children: _jsxs(Grid, { container: true, children: [_jsx(Grid, { item: true, xs: 12, sx: { mb: 1 }, children: _jsx(Logo, {}) }), _jsx(Grid, { item: true, xs: 12, sx: { my: 1 }, children: _jsx(H5, { children: "Log in" }) }), (alert && alert.position === 'top') && (_jsx(Grid, { item: true, xs: 12, children: _jsx(Alert, { severity: alert.severity, title: alert.title, children: alert.detail }) })), _jsx(Grid, { item: true, xs: 12, sx: { my: 1 }, children: _jsx(Scanner, { autoFocus: true, label: "Badge", showIcon: true, icon: _jsx(AccountCircle, {}), onScannerChange: handleChange, onEnter: handleSubmit, onClear: handleClear, hasError: !!error, helperText: "Scan the code on your badge or enter your badge credential to log in.", value: badge, disabled: isLoading }) }), (alert && alert?.position !== 'top') && (_jsx(Grid, { item: true, xs: 12, children: _jsx(Alert, { severity: alert.severity, title: alert.title, children: alert.detail }) })), _jsx(Grid, { item: true, xs: 12, sx: { mt: alert ? 1 : 2 }, children: _jsx(Button, { color: "primary", variant: "contained", label: "Log In", onClick: () => handleSubmit(), fullWidth: true, isWaiting: isLoading }) })] }) }));
};
//# sourceMappingURL=index.js.map